<template>

</template>

<script>
    // add imports here

    //ADD JSDOC HERE!!!!!
    export default {
        props: [],
        created() {
        },
        destroyed() {
        },
        mounted() {

        },
        data() {
            return {}
        },
        methods: {},
        computed: {}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTicketProps.vue?4a7297e2